import { List, useDataGrid } from "@refinedev/mui";
import React from "react";

import { IParticipation } from "./interfaces";
import { SearchToolbar, DataGridPanel, ListPageHeader } from "components/list";
import { participationColumns } from "./components/participationColumns";
import { participationSearchFields } from "./components/participationSearchFields";

export const ParticipationList: React.FC = () => {
    const { dataGridProps, setFilters, filters, tableQueryResult } =
        useDataGrid<IParticipation>({
            initialCurrent: 1,
            initialPageSize: 20,
            sorters: {
                initial: [{ field: "id", order: "desc" }],
            },
        });

    // refine의 rowCount는 fetch 중 잠깐 0으로 떨어져 "전체 0건"이 깜빡인다.
    const lastRowCountRef = React.useRef<number | undefined>(undefined);
    if (!dataGridProps.loading && typeof dataGridProps.rowCount === "number") {
        lastRowCountRef.current = dataGridProps.rowCount;
    }

    return (
        <List breadcrumb={<></>}>
            <ListPageHeader
                count={lastRowCountRef.current}
                description="설명회 신청 및 상태 현황"
            />

            <SearchToolbar
                fields={participationSearchFields}
                filters={filters}
                setFilters={setFilters}
            />

            <DataGridPanel
                {...dataGridProps}
                columns={participationColumns}
                isError={tableQueryResult.isError}
                errorMessage="설명회 신청 목록을 불러오지 못했습니다."
                emptyMessage="조건에 맞는 신청이 없습니다."
                pageSizeOptions={[10, 20, 30, 50, 100]}
                disableColumnFilter
                filterModel={undefined}
            />
        </List>
    );
};
